import { createFileRoute } from '@tanstack/react-router'
import BillingPage from '@/spa/pages/BillingPage'
import { routeErrorComponent } from './_shared/RouteError'

export const Route = createFileRoute('/billing')({
  component: BillingPage,
  errorComponent: routeErrorComponent,
})
